import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { catalogAccountType } from "../store/plan/actions";
export var useGetCatalogAccountType = function (trigger, projectId) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) { return ({
        responseCatalogAccountType: state.Plan.responseCatalogAccountType,
        loadingCatalogAccountType: state.Plan.loadingCatalogAccountType,
        errorCatalogAccountType: state.Plan.errorCatalogAccountType,
    }); }), responseCatalogAccountType = _d.responseCatalogAccountType, loadingCatalogAccountType = _d.loadingCatalogAccountType, errorCatalogAccountType = _d.errorCatalogAccountType;
    useEffect(function () {
        if (trigger) {
            dispatch(catalogAccountType({
                enable: true,
                page: 1,
                limit: 100,
                projectId: projectId,
            }));
        }
    }, [projectId, trigger]);
    return {
        responseCatalogAccountType: responseCatalogAccountType,
        errorCatalogAccountType: errorCatalogAccountType,
        loadingCatalogAccountType: loadingCatalogAccountType,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
